import { render, staticRenderFns } from "./Testimony.vue?vue&type=template&id=bf3b0da4&scoped=true&"
import script from "./Testimony.vue?vue&type=script&lang=js&"
export * from "./Testimony.vue?vue&type=script&lang=js&"
import style0 from "./Testimony.vue?vue&type=style&index=0&id=bf3b0da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3b0da4",
  null
  
)

export default component.exports